export enum PartnerType {
  ATT = "att",
  VERIZON = "verizon",
  COX = "cox",
  TELUS = "telus",
  KOODO = "koodo",
  US_CELLULAR = "uscellular",
  ASURION = "asurion",
  LIBERTY = "liberty",
}
